import { render } from "./AnswerCard.vue?vue&type=template&id=be901a5a&scoped=true"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"

import "./AnswerCard.vue?vue&type=style&index=0&id=be901a5a&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be901a5a"]])

export default __exports__